import { Link } from 'react-router-dom';
import { featuredGames } from '@/mocks/games';

export default function GameShowcase() {
  return (
    <section className="w-full px-4 md:px-6 py-12 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between gap-4 mb-10 md:mb-14">
          <div>
            <h2 className="text-2xl md:text-4xl font-heading text-foreground-950">
              热门麻将游戏
            </h2>
            <p className="mt-3 text-sm md:text-base text-foreground-600">
              精选最受欢迎的麻将玩法，总有一款适合你
            </p>
          </div>
          <Link
            to="/categories"
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            className="flex items-center gap-1 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors cursor-pointer whitespace-nowrap"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6" data-product-shop>
          {featuredGames.map((game) => (
            <Link
              key={game.id}
              to={`/categories?game=${game.id}`}
              onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
              className="group bg-background-50 rounded-lg overflow-hidden hover:shadow-md transition-all duration-200 cursor-pointer"
            >
              <div className="relative h-48 md:h-56 overflow-hidden">
                <img
                  src={game.image}
                  alt={game.name}
                  title={game.name}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-3 right-3 px-2.5 py-1 bg-primary-500 text-background-50 text-xs font-medium rounded-full whitespace-nowrap">
                  {game.rating} 分
                </div>
              </div>
              <div className="p-4 md:p-5">
                <div className="flex items-center justify-between mb-2">
                  <h3 className="text-base md:text-lg font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors">
                    {game.name}
                  </h3>
                  <span className="text-xs text-foreground-500 whitespace-nowrap">{game.players}</span>
                </div>
                <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2 mb-3">
                  {game.description}
                </p>
                <div className="flex items-center justify-between">
                  <span className="text-xs px-2.5 py-1 bg-secondary-100 text-secondary-800 rounded-full whitespace-nowrap">
                    {game.difficulty}
                  </span>
                  <span className="text-xs text-foreground-500 flex items-center gap-1">
                    <i className="ri-user-line"></i> {game.playCount} 游玩
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}